import { Box, Button, Typography } from '@mui/material';
import { TermAndConditionList } from '../../assets/api/useMarketingExecutive';
import TableFilterTemplate from '../../shared/utils/TableFilterTemplate';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useToaster } from '../../shared/utils/ToasterProvider';
import useAuthStore from '../../store/useAuthStore';
import api from '../../assets/nodeApi/axiosInstance';
// import api from '../../assets/api/useStudentPostApi';


const CommonTermAndConditionTable = ({ id }) => {
    const queryClient = useQueryClient();
    const { user, token } = useAuthStore();
    const { data: termConditionList, isLoading } = TermAndConditionList({ apartment_id: id })
    const termRows = termConditionList?.terms_history?.map((item, index) => ({
        id: item?.id,
        sr_no: index + 1,
        ...item


    })) || [];

    const { showToaster } = useToaster();


    const mutation = useMutation({
        mutationFn: (formData) => api.patch("apartment-terms/status", formData,
            {
                headers: {
                    Authorization: `Bearer ${token}`,
                },
            }
        ),
    });

    const handleAction = (id, status) => {
        const body = {
            id: id,
            status: status,
        };
        mutation.mutate(body, {
            onSuccess: () => {
                {
                    status === 2 ? showToaster('Success', "Thank you! You've successfully accepted the Terms and Condition", 'success') : showToaster("You’ve declined the Terms and Conditions", 'Warning', 'warning')
                }
                queryClient.invalidateQueries({ queryKey: ['apartment-terms/by-apartment'] });

            },
            onError: () => {
                showToaster("Something Went wrong", 'Error', 'error')
            }
        });

    }


    const handleApprove = (id) => {
        const body = { id, status: 1 };
        mutation.mutate(body, {
            onSuccess: (response) => {
                showToaster('Success', response?.data?.message, 'success');
                queryClient.invalidateQueries({ queryKey: ['apartment-terms/by-apartment'] });

            },
            onError: () => {
                showToaster("Something Went wrong", 'Error', 'error');
            }
        });
    };


    const termColumn = [
        {
            field: "sr_no",
            headerName: "Sr No",
            width: 100,
            renderCell: (params) => <Typography variant="body2">{params.value}</Typography>

        },
        // {
        //     field: "date_of_approval",
        //     headerName: "Date Of Approval",
        //     flex: 1,
        //     renderCell: (params) => <Typography variant="body2">{params.value}</Typography>

        // },

        {
            field: "security_deposit",
            headerName: "Security Deposit",
            width: 200,
            renderCell: (params) => <Typography variant="body2">{params.value}</Typography>,
        },

        {
            field: "terms_conditions",
            headerName: "Terms Condition",
            width: 200,
            renderCell: (params) => <Typography variant="body2" >
                {params.value}
            </Typography>,
        },


        // {
        //     field: "approved_by",
        //     headerName: "Approved By",
        //       width:200,
        //     renderCell: (params) => <Typography variant="body2">{params.value}</Typography>

        // },
        ...(user?.role !== "organizer"
            ? [
                {
                    field: "status_label",
                    headerName: "Status",
                    width: 200,
                    renderCell: (params) => <Typography variant="body2">{params.value}</Typography>,
                },
            ]
            : []),




        ...(user?.role === "organizer"
            ? [
                {
                    field: "status_label",
                    headerName: "Status",
                    width: 250,
                    renderCell: (params) => (
                        <>
                            {
                                params?.row?.status === 1 ?
                                    <Box sx={{display:"flex",gap:1}}>
                                          <Button variant='contained' onClick={() => handleAction(params?.row?.id, 2)} disabled={params?.row?.status !== 1}>
                                            Approve
                                        </Button>
                                        <Button variant='contained' onClick={() => handleAction(params?.row?.id, 3)} disabled={params?.row?.status !== 1}>
                                            Reject
                                        </Button>
                                      
                                    </Box> : <Typography variant="body2">{params.value}</Typography>

                            }

                        </>

                    ),
                }
            ]
            : []),

        ...((user.role === "Marketing Manager" || user.role === "Admin")
            ? [
                {
                    field: "approve",
                    headerName: "Approve",
                    width: 200,
                    renderCell: (params) => (
                        <Button variant='contained' onClick={() => handleApprove(params?.row?.id)} disabled={params?.row?.status !== 0}>
                            Approve
                        </Button>
                    ),
                },

            ]
            : [])

    ];





    return (
        <>
            <TableFilterTemplate
                title="Term And Condition List"
                columns={termColumn}
                rowsData={termRows || []}
                isLoading={isLoading}



            />


        </>
    )
}

export default CommonTermAndConditionTable